export type ChoirsOverviewGuideStepId = "join_choir" | "create_choir";

export interface ChoirsOverviewGuideState {
    completed: ChoirsOverviewGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIRS_OVERVIEW_GUIDE_STEPS: ChoirsOverviewGuideStepId[] = [
    "join_choir",
    "create_choir",
];

export function createDefaultChoirsOverviewGuideState(
    seed?: Partial<ChoirsOverviewGuideState> | null
): ChoirsOverviewGuideState {
    const completed = Array.isArray(seed?.completed)
        ? seed!.completed.filter((step): step is ChoirsOverviewGuideStepId => CHOIRS_OVERVIEW_GUIDE_STEPS.includes(step as ChoirsOverviewGuideStepId))
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirsOverviewGuideNextStep(
    state: ChoirsOverviewGuideState,
    targetStep?: ChoirsOverviewGuideStepId | null
): ChoirsOverviewGuideStepId | null {
    const completed = new Set(state.completed || []);
    if (targetStep) {
        return completed.has(targetStep) ? null : targetStep;
    }
    return CHOIRS_OVERVIEW_GUIDE_STEPS.find((step) => !completed.has(step)) || null;
}

export function isChoirsOverviewGuideStepCompleted(
    state: ChoirsOverviewGuideState,
    step: ChoirsOverviewGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirsOverviewGuideStep(
    state: ChoirsOverviewGuideState,
    step: ChoirsOverviewGuideStepId
): ChoirsOverviewGuideState {
    if (state.completed.includes(step)) {
        return state;
    }

    const nextCompleted = [...state.completed, step];
    const done = nextCompleted.length >= CHOIRS_OVERVIEW_GUIDE_STEPS.length;
    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
